import { computed, inject, provide, ref } from "vue";
import { useMediaQuery } from "@vueuse/core";

export const SIDEBAR_COOKIE_NAME = "sidebar_state";
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
export const SIDEBAR_WIDTH = "16rem";
export const SIDEBAR_WIDTH_MOBILE = "18rem";
export const SIDEBAR_WIDTH_ICON = "3rem";
export const SIDEBAR_KEYBOARD_SHORTCUT = "b";

const SidebarSymbol = Symbol("SidebarContext");

export function useSidebar() {
  const context = inject(SidebarSymbol);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }
  return context;
}

export function provideSidebar(props) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const open = ref(props.defaultOpen ?? true);
  const openMobile = ref(false);

  const state = computed(() => (open.value ? "expanded" : "collapsed"));

  function setOpen(value) {
    open.value = value;
  }

  function setOpenMobile(value) {
    openMobile.value = value;
  }

  function toggleSidebar() {
    if (isMobile.value) {
      openMobile.value = !openMobile.value;
    } else {
      open.value = !open.value;
    }
  }

  const context = {
    state,
    open,
    setOpen,
    isMobile,
    openMobile,
    setOpenMobile,
    toggleSidebar,
  };

  provide(SidebarSymbol, context);
  return context;
}
